import React from 'react';
import styled from 'styled-components';
import moment from 'moment';

const Timer = styled.div`
    font-size: 36px;
    color: #FFF;
`

class Time extends React.Component {

    constructor(props) {
        super(props);
        this.state = {date: new Date()};
    }

    componentDidMount() {
        this.timerID = setInterval(
            () => this.tick(),
            1000
        );
    }

    componentWillUnmount() {
        clearInterval(this.timerID);
    }

    tick() {
        this.setState({
            date: new Date()
        });
    }

    render() {
        return(
            <Timer>
                <h1>{ moment(this.state.date).format('LT') }</h1>
            </Timer>
        )
    }
}

export default Time;


// WEBPACK FOOTER //
// ./src/components/Time.js